import { RootState } from 'handlers';

export const getYourIncome = ({ yourIncome }: RootState) => yourIncome;

export const getYourIncomeVariant = ({ yourIncome }: RootState) => yourIncome.variant;
